import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FeedbackPreviewModel } from 'common/models/page-models/feedback-preview/feedback-preview-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { FeedbackPreviewWidgetService } from 'common/widget/feedback/feedback-preview-widget';

@Injectable({
    providedIn: 'root',
})
export class FeedbackPreviewResolver extends FormResolverService<FeedbackPreviewModel> {
    constructor(
        protected fs: FeedbackPreviewWidgetService,
        protected override  router: Router,
        protected override  systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

     override modifyResponseData(dataModel: any, meta: any, widget: any) {
        const previewModel = new FeedbackPreviewModel();
        dataModel.questions.forEach((question) => {
            //console.log(question);
            previewModel[question.id] = null;
        });
        // dataModel[0].questions.forEach((question) => {
        //     if (question.options.length > 0 && question.questionType === '7' && question.questionType === '4' && question.questionType === '2') {
        //         question.options.forEach((option) => {
        //             previewModel[option.id] = null;
        //         })

        //     } else {
        //         previewModel[question.id] = null;

        //     }
        // });
        // console.log(previewModel)
        return previewModel;
    }
}
